import React from 'react';
import { BellIcon, CheckIcon, ClockIcon } from 'lucide-react';
export function FollowUpScreen() {
  // Mock data for follow-ups
  const followUps = [{
    id: 'f1',
    name: 'Jamie Wilson',
    company: 'CreativeHub',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200&auto=format&fit=crop',
    dueDate: 'Today',
    notes: 'Send portfolio and schedule meeting next week',
    completed: false
  }, {
    id: 'f2',
    name: 'Taylor Reed',
    company: 'InvestCap',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop',
    dueDate: 'Today',
    notes: 'Share pitch deck and follow up about funding',
    completed: false
  }, {
    id: 'f3',
    name: 'Morgan Chen',
    company: 'TechNova',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200&auto=format&fit=crop',
    dueDate: 'Yesterday',
    notes: 'Discuss potential partnership opportunities',
    completed: true
  }];
  return <div className="flex flex-col flex-1" data-id="element-97">
      <header className="p-4 flex items-center justify-between border-b" data-id="element-98">
        <h1 className="text-xl font-bold text-gray-800" data-id="element-99">Follow Ups</h1>
        <button className="p-2 rounded-full hover:bg-gray-100" data-id="element-100">
          <BellIcon size={20} className="text-gray-600" data-id="element-101" />
        </button>
      </header>
      <div className="flex-1 p-4" data-id="element-102">
        <div className="mb-6" data-id="element-103">
          <h2 className="text-lg font-semibold text-gray-700 mb-3" data-id="element-104">Pending</h2>
          {followUps.filter(item => !item.completed).map(item => <div key={item.id} className="bg-white rounded-lg shadow-sm p-4 mb-3 border border-gray-100" data-id="element-105">
                <div className="flex items-center gap-3 mb-2" data-id="element-106">
                  <img src={item.image} alt={item.name} className="w-12 h-12 rounded-full object-cover" data-id="element-107" />
                  <div className="flex-1" data-id="element-108">
                    <h3 className="font-medium" data-id="element-109">{item.name}</h3>
                    <p className="text-sm text-gray-500" data-id="element-110">{item.company}</p>
                  </div>
                  <div className="flex items-center text-sm text-indigo-600" data-id="element-111">
                    <ClockIcon size={14} className="mr-1" data-id="element-112" />
                    {item.dueDate}
                  </div>
                </div>
                <p className="text-sm text-gray-600" data-id="element-113">{item.notes}</p>
                <div className="flex gap-2 mt-3" data-id="element-114">
                  <button className="flex-1 bg-indigo-600 text-white py-2 rounded-md text-sm" data-id="element-115">
                    Send Follow-up
                  </button>
                  <button className="px-3 py-2 border border-gray-300 rounded-md" data-id="element-116">
                    <CheckIcon size={16} data-id="element-117" />
                  </button>
                </div>
              </div>)}
        </div>
        <div data-id="element-118">
          <h2 className="text-lg font-semibold text-gray-700 mb-3" data-id="element-119">
            Completed
          </h2>
          {followUps.filter(item => item.completed).map(item => <div key={item.id} className="bg-white rounded-lg shadow-sm p-4 mb-3 border border-gray-100 opacity-70" data-id="element-120">
                <div className="flex items-center gap-3 mb-2" data-id="element-121">
                  <img src={item.image} alt={item.name} className="w-12 h-12 rounded-full object-cover" data-id="element-122" />
                  <div className="flex-1" data-id="element-123">
                    <h3 className="font-medium" data-id="element-124">{item.name}</h3>
                    <p className="text-sm text-gray-500" data-id="element-125">{item.company}</p>
                  </div>
                  <div className="flex items-center text-sm text-green-600" data-id="element-126">
                    <CheckIcon size={14} className="mr-1" data-id="element-127" />
                    Done
                  </div>
                </div>
                <p className="text-sm text-gray-600" data-id="element-128">{item.notes}</p>
              </div>)}
        </div>
      </div>
    </div>;
}